import { LOCALIZED, stringifyStoreId } from '@libs/core';

export const localizedWebInventory = LOCALIZED.webInventory;

export const getInventoryStoreId = (storeId?: string | number) => {
    const stringifiedStoreId = stringifyStoreId(storeId);

    switch (true) {
        case stringifiedStoreId && stringifiedStoreId !== localizedWebInventory:
            return `ps_${LOCALIZED.localeShorthand}_store_inv_${stringifiedStoreId}`;
        case storeId === localizedWebInventory:
            return localizedWebInventory;
        default:
            return stringifiedStoreId;
    }
};
